import { useForm } from 'react-form';
import React from 'react';
const ControllingForm = ({ children, onSubmit, debug = false, className = '', autoSubmit = false, }) => {
    const onChange = (values) => {
        if (autoSubmit) {
            onSubmit(values);
        }
        return !autoSubmit;
    };
    const { Form, meta: { isSubmitting, canSubmit }, } = useForm({
        onSubmit,
        debugForm: debug,
        validate: onChange,
    });
    return React.createElement(Form, { className: className }, children);
};
export default ControllingForm;
//# sourceMappingURL=ControllingForm.js.map